import { notification } from 'antd'
import { CheckIcon, CloseIcon2 } from 'components/Icons'

const popupSuccess = (success : string) => {
  notification.open({
    message: success,
    icon: <CheckIcon />,
    closeIcon: <CloseIcon2 />,
    className: 'success-popup'
  })
}

export default popupSuccess
